/**
 * Map API date_of_birth to a date-only form value (YYYY-MM-DD).
 * Do not use split('T')[0] on full ISO strings — that is the UTC date and is one day early in UTC+ zones.
 */
export function apiDateOnlyToDateInputValue(value) {
  if (value == null || value === '') return '';
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) {
    const head = s.split('T')[0].split(' ')[0];
    return /^\d{4}-\d{2}-\d{2}$/.test(head) ? head : '';
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
